import request from '@/util/http';

export default {
  userList,         //获取用户列表
  userInfo,         //获取用户详情
  getRole,          //获取角色
  setRole,          //分配后台角色
  delCom,           //踢出公司
  activecarddetail, //根据用户id和公司id查询用户信息
  activecard,       //刀具柜激活
  djglist,          //刀具柜列表
  adddjg,           //添加刀具柜
  getdeviceoperlist,//获取设备运营人员
  setdeviceoper,    //设置设备运营人员
  getpaytypelist, //设备支付方式获取
  setdevicepaytype,//设置支付方式
  deviceislock,     //锁定/解锁设备
  getgoodssortlist, //分类列表查询
  addorupdatesort,  //新增修改分类
  opersortstate,    //分类状态设置
  getgoodscommlist, //标品库列表
  uploadfile,       //文件上传
  addorupdategoodscomm, //标准库添加修改
  getgoodslist,     //商品列表
  addorupdatecupgoods,//从标准库添加商品/修改价格分类
  adlist,           //广告列表
  addorupdatecupad, //设备广告添加修改
  delad,            //删除广告
  channellist,      //货道列表
  addorupdatecupchannel,//添加修改货道
  delchannel,       //货道删除
  getorderlist,     //历史记录列表
  getchannellist,   //货道管理列表
  exportbydataorderlist,//历史记录导出
  getlogfilelist,   //设备日志列表
  getdeviceversionlist,//版本列表
  adddeviceversion, //添加修改版本号
  deldeviceversion, //删除刀具柜版本
  getdevicefaultlist,/*设备故障列表*/
  getComList,/*获取公司列表*/
  delimitdevice,/*分配公司*/
  adsUser,/*分配角色*/
  hqdj,/*获取刀具*/
  saveData,/*设置分配刀具权限*/
  seaLqqx,/*查看刀具柜领取选前*/
  getgoodslistSh,
  updateMoible,
  updateMaxNumber,
  cancelchannel, //拆分
  andchannel,  //并道
  getchannelwarn,//报警货道列表
  addorupdatecupchannels,//修改是否允许还刀到货道
  exportqhhd,//导出缺货货道表
  exportbhmx,//导出缺货货道表
}

function exportbhmx(data) {
  return request({
    url: '/excel/api/exportbhmx',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

function exportqhhd(data) {
  return request({
    url: '/excel/api/exportqhhd',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

function addorupdatecupchannels(data) {
  return request({
    url: '/devicecabinet/api/addorupdatecupchannel',
    method: 'post',
    data
  })
}

function getchannelwarn(data) {
  return request({
    url: 'devicecabinet/api/getchannelwarn',
    method: 'post',
    data
  })
}

function andchannel(data) {
  return request({
    url: 'devicecabinetapp/api/andchannel',
    method: 'post',
    data
  })
}

function cancelchannel(data) {
  return request({
    url: 'devicecabinetapp/api/cancelchannel',
    method: 'post',
    data
  })
}

function updateMaxNumber(data) {
  return request({
    url: 'devicecabinet/api/updateMaxNumber',
    method: 'post',
    data
  })
}

function updateMoible(data) {
  return request({
    url: 'user/api/updateMoible',
    method: 'post',
    data
  })
}

function getgoodslistSh(data) {
  return request({
    url: 'devicecabinet/api/getgoodslist',
    method: 'post',
    data
  })
}

function seaLqqx(data) {
  return request({
    url: 'devicecabinet/api/getusergoodsauthlist',
    method: 'post',
    data
  })
}

function saveData(data) {
  return request({
    url: 'devicecabinet/api/setdevicegoodsauth',
    method: 'post',
    data
  })
}

function hqdj(data) {
  return request({
    url: 'devicecabinet/api/getdevicegoodsauthlist',
    method: 'post',
    data
  })
}

function adsUser(data) {
  return request({
    url: 'user/api/adduser',
    method: 'post',
    data
  })
}

function delimitdevice(data) {
  return request({
    url: 'devicecabinet/api/delimitdevice',
    method: 'post',
    data
  })
}

function getComList(data) {
  return request({
    url: 'sys/api/companylist',
    method: 'post',
    data
  })
}

function getdevicefaultlist(data) {
  return request({
    url: 'devicecabinet/api/getdevicefaultlist',
    method: 'post',
    data
  })
}

function deldeviceversion(data) {
  return request({
    url: 'devicecabinet/api/deldeviceversion',
    method: 'post',
    data
  })
}

function adddeviceversion(data) {
  return request({
    url: 'devicecabinet/api/adddeviceversion',
    method: 'post',
    data
  })
}

function getdeviceversionlist(data) {
  return request({
    url: 'devicecabinet/api/getdeviceversionlist',
    method: 'post',
    data
  })
}

function getlogfilelist(data) {
  return request({
    url: 'devicecabinet/api/getlogfilelist',
    method: 'post',
    data
  })
}

function exportbydataorderlist(data) {
  return request({
    url: 'excel/api/exportbydataorderlist',
    method: 'post',
    responseType:'blob',
    data
  })
}

function getchannellist(data) {
  return request({
    url: 'devicecabinet/api/getchannellist',
    method: 'post',
    name:'post',
    data
  })
}

function getorderlist(data) {
  return request({
    url: 'devicecabinet/api/getorderlist',
    method: 'post',
    name:'post',
    data
  })
}

function delchannel(data) {
  return request({
    url: 'devicecabinet/api/delchannel',
    method: 'post',
    name:'post',
    data
  })
}

function addorupdatecupchannel(data) {
  return request({
    url: 'devicecabinet/api/addorupdatecupchannel',
    method: 'post',
    name:'post',
    data
  })
}

function channellist(data) {
  return request({
    url: 'devicecabinet/api/channellist',
    method: 'post',
    name:'post',
    data
  })
}

function delad(data) {
  return request({
    url: 'devicecabinet/api/delad',
    method: 'post',
    name:'post',
    data
  })
}

function addorupdatecupad(data) {
  return request({
    url: 'devicecabinet/api/addorupdatecupad',
    method: 'post',
    name:'post',
    data
  })
}

function adlist(data) {
  return request({
    url: 'devicecabinet/api/adlist',
    method: 'post',
    name:'post',
    data
  })
}

function addorupdatecupgoods(data) {
  return request({
    url: 'devicecabinet/api/addorupdatecupgoods',
    method: 'post',
    name:'post',
    data
  })
}

function getgoodslist(data) {
  return request({
    url: 'devicecabinet/api/getgoodslist',
    method: 'post',
    name:'post',
    data
  })
}

function addorupdategoodscomm(data) {
  return request({
    url: 'devicecabinet/api/addorupdategoodscomm',
    method: 'post',
    name:'post',
    data
  })
}

function uploadfile(data) {
  return request({
    url: 'gyy/api/uploadfile',
    method: 'post',
    name:'file',
    data
  })
}

function getgoodscommlist(data) {
  return request({
    url: 'devicecabinet/api/getgoodscommlist',
    method: 'post',
    data
  })
}

function opersortstate(data) {
  return request({
    url: 'devicecabinet/api/opersortstate',
    method: 'post',
    data
  })
}

function addorupdatesort(data) {
  return request({
    url: 'devicecabinet/api/addorupdatesort',
    method: 'post',
    data
  })
}

function getgoodssortlist(data) {
  return request({
    url: 'devicecabinet/api/getgoodssortlist',
    method: 'post',
    data
  })
}

function deviceislock(data) {
  return request({
    url: 'devicecabinet/api/deviceislock',
    method: 'post',
    data
  })
}

function setdevicepaytype(data) {
  return request({
    url: 'devicecabinet/api/setdevicepaytype',
    method: 'post',
    data
  })
}

function getpaytypelist(data) {
  return request({
    url: 'devicecabinet/api/getpaytypelist',
    method: 'post',
    data
  })
}

function setdeviceoper(data) {
  return request({
    url: 'devicecabinet/api/setdeviceoper',
    method: 'post',
    data
  })
}

function getdeviceoperlist(data) {
  return request({
    url: 'devicecabinet/api/getdeviceoperlist',
    method: 'post',
    data
  })
}

function adddjg(data) {
  return request({
    url: 'devicecabinet/api/adddevice',
    method: 'post',
    data
  })
}

function djglist(data) {
  return request({
    url: 'devicecabinet/api/devicelist',
    method: 'post',
    data
  })
}

function activecard(data) {
  return request({
    url: 'devicecabinet/api/activecard',
    method: 'post',
    data
  })
}

function activecarddetail(data) {
  return request({
    url: 'devicecabinet/api/activecarddetail',
    method: 'post',
    data
  })
}

function userList(data) {
  return request({
    url: 'sys/api/userlist',
    method: 'post',
    data
  })
}

function userInfo(data) {
  return request({
    url: 'sys/api/getuserdetail',
    method: 'post',
    data
  })
}

function getRole(data) {
  return request({
    url: 'sys/api/getrole',
    method: 'post',
    data
  })
}

function setRole(data) {
  return request({
    url: 'sys/api/usertorole',
    method: 'post',
    data
  })
}

function delCom(data) {
  return request({
    url: 'sys/api/outcompany',
    method: 'post',
    data
  })
}